import React, { Component } from 'react';
import _ from 'lodash';

class TableBody extends Component {
  renderCell = (item, column) => {

    if (column.content) {
      return column.content(item)
    }

    let cellContent = _.get(item, column.path);
    
    if (column.path === 'createdAt') {
      cellContent = this.pretyDate(cellContent);
    }
    
    if (column.path === 'updatedAt') {
      cellContent = this.pretyDate(cellContent);
    }
    
    if (column.path === 'lastClickAt') {
      cellContent = this.pretyDate(cellContent);
    }

    if (column.path === 'originalUrl' || column.path === 'shortUrl') {
      cellContent = <a href={cellContent}>{cellContent}</a>;
    }

    return cellContent;
  };

  pretyDate = (dateString) => {
    const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    let dateObj = new Date(Date.parse(dateString));
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, '0');
    let year = dateObj.getFullYear();
    let hours = (dateObj.getHours() < 10 ? '0' : '') + dateObj.getHours();
    let minutes = (dateObj.getMinutes() < 10 ? '0' : '') + dateObj.getMinutes();
    let seconds = (dateObj.getSeconds() < 10 ? '0' : '') + dateObj.getSeconds();
    let output = <span className="date-wrapper">{month} {day}, {year}<br/>{hours}:{minutes}:{seconds}</span>;
    return output;
  } 

  createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  render() {
    const { data, columns } = this.props;
    return (
      <tbody>
        {data.map(item => (
          <tr key={item._id}>
            {columns.map(column => (
              <td key={this.createKey(item, column)} className="table-td">
                {this.renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}

export default TableBody;



// WEBPACK FOOTER //
// ./src/components/Table/tablebody.js